import React from "react";
import { IndianRupee, DollarSign, Euro, PoundSterling, JapaneseYen } from "lucide-react";

/**
 * CurrencyIcon — picks the right Lucide icon for a 3-letter currency code.
 * Extracted from ChatsPage.jsx (iter 156.2, Feb 2026).
 *
 * Falls back to ₹ when the currency isn't recognised.
 */
export function CurrencyIcon({ currency, size = 14, className = "" }) {
  const cur = (currency || "INR").toUpperCase();
  if (cur === "USD" || cur === "CAD" || cur === "AUD" || cur === "SGD") {
    return <DollarSign size={size} className={className} />;
  }
  if (cur === "EUR") return <Euro size={size} className={className} />;
  if (cur === "GBP") return <PoundSterling size={size} className={className} />;
  if (cur === "JPY") return <JapaneseYen size={size} className={className} />;
  return <IndianRupee size={size} className={className} />;
}
